<div class="hidden xl:block tab-content" id="settingsContent">
  <div
    class="mb-3 mt-2 flex flex-col lg:flex-row justify-between items-center p-3 card_color rounded-lg space-y-4 lg:space-y-0">
    <!-- Título -->
    <h1 class="pl-2 text-md lg:text-xl font-medium text_white">Últimas
      Transacciones</h1>

    <!-- Campo de búsqueda -->
    <div class="relative w-full lg:w-1/3">
      <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
        <!-- Ícono de búsqueda -->
        <svg class="w-5 h-5 text_color_customize" fill="none" stroke="currentColor" viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-4.35-4.35m0 0a8.5 8.5 0 111.84-1.84l4.35 4.35z">
          </path>
        </svg>
      </div>
      <input (input)="searchInTable($any($event.target).value)" type="search" placeholder="Buscar transacciones..."
        class="w-full pl-10 p-3 text-sm bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
    </div>
  </div>

  <!-- Table -->
  <div class="flex flex-col">
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full align-middle">
        <div class="overflow-hidden">
          <table class="min-w-full divide_y_customize divide_color_customize">
            <thead>
              <tr>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-lock-dollar">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10" />
                          <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
                          <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
                          <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                          <path d="M19 21v1m0 -8v1" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> ID
                        Transacción</span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-transform">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                          <path d="M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3" />
                          <path d="M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3" />
                          <path d="M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> ID Tipo
                        de Operación </span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text-xl text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-cash">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
                          <path d="M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z" />
                          <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> Monto de
                        créditos</span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-clock-hour-4">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                          <path d="M12 12l3 2" />
                          <path d="M12 7v5" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> Fecha y
                        hora</span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="divide_y_customize divide_color_customize">
              <ng-container *ngIf="items.length === 0; else elseTemplate">
                <tr>
                  <td class="opacity-50 py-10 text-md font-normal whitespace-nowrap flex-1 text-white" colspan="4"
                    style="text-align: center; min-height: 100px;">
                    <div class="flex flex-col items-center justify-center w-full">
                      <i class="ti ti-alert-circle no-items text-gray-100 text-4xl"></i>
                      <span class="mt-2 text-gray-100 fontcustom">Sin información por mostrar</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #elseTemplate>
                <tr *ngFor="let item of items">
                  <td class="p-4 text-sm font-normal text_gray whitespace-nowrap">
                    <div class="flex items-center text_white">
                      {{item.id.slice(0,14)}}
                    </div>
                  </td>
                  <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                    <div class="flex items-center space-x-2">
                      <dd *ngIf="item.transactionType.description === 'withdraw'"
                        class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_yellow text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text_red text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-up">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                            <path d="M12 8l-4 4" />
                            <path d="M12 8v8" />
                            <path d="M16 12l-4 -4" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">Retiro</span>
                      </dd>
                      <dd *ngIf="item.transactionType.description === 'bonus'"
                        class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_blue text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-2xl text_blue icon icon-tabler icons-tabler-outline icon-tabler-gift">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                            <path d="M12 8l0 13" />
                            <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
                            <path
                              d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">
                          Bono</span>
                      </dd>
                      <dd *ngIf="item.transactionType.description === 'sell'"
                        class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_yellow text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-xl text_green icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-down">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                            <path d="M8 12l4 4" />
                            <path d="M12 8v8" />
                            <path d="M16 12l-4 4" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">Compra</span>
                      </dd>
                    </div>
                  </td>
                  <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                    <div class="flex items-center space-x-2">
                      <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_yellow text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                            <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                            <path d="M12 3v4" />
                            <path d="M12 17v4" />
                            <path d="M3 12h4" />
                            <path d="M17 12h4" />
                            <path d="M18.364 5.636l-2.828 2.828" />
                            <path d="M8.464 15.536l-2.828 2.828" />
                            <path d="M5.636 5.636l2.828 2.828" />
                            <path d="M15.536 15.536l2.828 2.828" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">{{item.creditsAmount}}</span>
                      </dd>
                    </div>
                  </td>
                  <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                    {{ item.createdAt | date: 'dd MMM yyyy / HH:mm':'UTC' }}
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Card Footer -->

  <!-- Paginador Últimas Transacciones -->

  <div
    class="flex items-center justify-center border-t border-t-2 border_customize_card card_color px-4 py-3 sm:px-6 rounded-b-lg shadow-md">
    <div class="hidden lg:flex lg:flex-1 lg:items-center lg:justify-between lg:flex-nowrap">
      <div>
        <p class="text-sm text_white flex items-center whitespace-nowrap">
          Mostrando las ultimas {{showing}} entradas
          <span class="font-medium mx-1">{{from}}</span>
          al
          <span class="font-medium mx-1">{{to}}</span>
          de
          <span class="font-medium mx-1">{{total}}</span>
        </p>
      </div>
    </div>





    <div
      class="flex items-center justify-between border_customize_card card_color px-4 py-3 sm:px-6 rounded-b-lg shadow-md">
      <!-- ... (tu código existente) ... -->
      <div class="w-full flex justify-center lg:justify-end">
        <nav class="isolate inline-flex -space-x-px" aria-label="Pagination">
          <!-- Flecha "Anterior" -->
          <a (click)="previousPage()"
            class="rounded-l-md relative inline-flex items-center text_color_customize hover:text_black px-2 py-2 line_customize line_inset_customize hover:button_color_customize">
            <span class="sr-only">Previo</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-left">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18" />
              <path d="M8 12l4 4" />
              <path d="M8 12h8" />
              <path d="M12 8l-4 4" />
            </svg>
          </a>

          <button *ngFor="let page of pages"
            [ngClass]="page === pagination.currentPage ? 
              'page-link relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold line_customize line_inset_customize hover:button_color_customize template_color_customize'
              :
              'page-link relative z-10 inline-flex items-center text_white hover:text_black px-4 py-2 text-sm font-semibold line_customize line_inset_customize hover:button_color_customize'"
            (click)="goToPage(page)" [disabled]="page === '...'">
            {{ page }}
          </button>

          <!-- Flecha "Siguiente" -->
          <a (click)="nextPage()"
            class="relative inline-flex items-center text_color_customize hover:text_black px-2 py-2 line_customize line_inset_customize hover:button_color_customize rounded-r-md">
            <span class="sr-only">Próximo</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-right">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" />
              <path d="M16 12l-4 -4" />
              <path d="M16 12h-8" />
              <path d="M12 16l4 -4" />
            </svg>
          </a>
        </nav>
      </div>
    </div>











  </div>
</div>
<!-- MOBILE -->
<div class="accordion-content px-4 py-3 text_gray card_color xl:hidden" id="settingsContent">
  <div
    class="mb-3 mt-2 flex flex-col lg:flex-row justify-between items-center p-3 card_color rounded-lg space-y-4 lg:space-y-0">
    <!-- Título -->
    <h1 class="pl-2 text-md lg:text-xl font-medium text_white">Últimas
      Transacciones</h1>

    <!-- Campo de búsqueda -->
    <div class="relative w-full lg:w-1/3">
      <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
        <!-- Ícono de búsqueda -->
        <svg class="w-5 h-5 text_color_customize" fill="none" stroke="currentColor" viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-4.35-4.35m0 0a8.5 8.5 0 111.84-1.84l4.35 4.35z">
          </path>
        </svg>
      </div>
      <input (input)="searchInTable($any($event.target).value)" type="search" placeholder="Buscar transacciones..."
        class="w-full pl-10 p-3 text-sm bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
    </div>
  </div>

  <!-- Table -->
  <div class="flex flex-col">
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full align-middle">
        <div class="overflow-hidden">
          <table class="min-w-full divide_y_customize divide_color_customize">
            <thead>
              <tr>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-lock-dollar">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10" />
                          <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
                          <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
                          <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                          <path d="M19 21v1m0 -8v1" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> ID
                        Transacción</span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-transform">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                          <path d="M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3" />
                          <path d="M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3" />
                          <path d="M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> ID Tipo
                        de Operación </span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text-xl text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-cash">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
                          <path d="M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z" />
                          <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> Monto de
                        créditos</span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
                <th scope="col" class="p-4 text-xs font-medium tracking-wider text-left text_white uppercase">
                  <div class="flex items-center space-x-2">
                    <dd class="text-sm font-semibold text_white flex items-center gap-2">
                      <span class="text_yellow text-xl gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-clock-hour-4">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                          <path d="M12 12l3 2" />
                          <path d="M12 7v5" />
                        </svg>
                      </span>
                      <span class="hidden sm:inline"> Fecha y
                        hora</span>
                      <!-- Solo muestra el texto en pantallas grandes -->
                    </dd>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="divide_y_customize divide_color_customize">
              <ng-container *ngIf="items.length === 0; else elseTemplate">
                <tr>
                  <td class="opacity-50 py-10 text-md font-normal whitespace-nowrap flex-1 text-white" colspan="4"
                    style="text-align: center; min-height: 100px;">
                    <div class="flex flex-col items-center justify-center w-full">
                      <i class="ti ti-alert-circle no-items text-gray-100 text-4xl"></i>
                      <span class="mt-2 text-gray-100 fontcustom">Sin información por mostrar</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #elseTemplate>
                <tr *ngFor="let item of items">
                  <td class="p-4 text-sm font-normal text_gray whitespace-nowrap">
                    <div class="flex items-center text_white">
                      {{item.id.slice(0,14)}}
                    </div>
                  </td>
                  <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                    <div class="flex items-center space-x-2">
                      <dd *ngIf="item.transactionType.description === 'withdraw'"
                        class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_yellow text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text_red text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-up">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                            <path d="M12 8l-4 4" />
                            <path d="M12 8v8" />
                            <path d="M16 12l-4 -4" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">Retiro</span>
                      </dd>
                      <dd *ngIf="item.transactionType.description === 'bonus'"
                        class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_blue text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-2xl text_blue icon icon-tabler icons-tabler-outline icon-tabler-gift">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                            <path d="M12 8l0 13" />
                            <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
                            <path
                              d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">
                          Bono</span>
                      </dd>
                      <dd *ngIf="item.transactionType.description === 'sell'"
                        class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_yellow text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-xl text_green icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-down">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                            <path d="M8 12l4 4" />
                            <path d="M12 8v8" />
                            <path d="M16 12l-4 4" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">Compra</span>
                      </dd>
                    </div>
                  </td>
                  <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                    <div class="flex items-center space-x-2">
                      <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                        <span class="text_yellow text-xl gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                            <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                            <path d="M12 3v4" />
                            <path d="M12 17v4" />
                            <path d="M3 12h4" />
                            <path d="M17 12h4" />
                            <path d="M18.364 5.636l-2.828 2.828" />
                            <path d="M8.464 15.536l-2.828 2.828" />
                            <path d="M5.636 5.636l2.828 2.828" />
                            <path d="M15.536 15.536l2.828 2.828" />
                          </svg>
                        </span>
                        <span class="font-medium text_white">{{item.creditsAmount}}</span>
                      </dd>
                    </div>
                  </td>
                  <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                    {{ item.createdAt | date: 'dd MMM yyyy / HH:mm' }}
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Card Footer -->

  <!-- Paginador Últimas Transacciones -->

  <div
    class="flex items-center justify-center border-t border-t-2 border_customize_card card_color px-4 py-3 sm:px-6 rounded-b-lg shadow-md">
    <div class="hidden lg:flex lg:flex-1 lg:items-center lg:justify-between lg:flex-nowrap">
      <div>
        <p class="text-sm text_white flex items-center whitespace-nowrap">
          Mostrando las ultimas {{showing}} entradas
          <span class="font-medium mx-1">{{from}}</span>
          al
          <span class="font-medium mx-1">{{to}}</span>
          de
          <span class="font-medium mx-1">{{total}}</span>
        </p>
      </div>
    </div>





    <div
      class="flex items-center justify-between border_customize_card card_color px-4 py-3 sm:px-6 rounded-b-lg shadow-md">
      <!-- ... (tu código existente) ... -->
      <div class="w-full flex justify-center lg:justify-end">
        <nav class="isolate inline-flex -space-x-px" aria-label="Pagination">
          <!-- Flecha "Anterior" -->
          <a (click)="previousPage()"
            class="rounded-l-md relative inline-flex items-center text_color_customize hover:text_black px-2 py-2 line_customize line_inset_customize hover:button_color_customize">
            <span class="sr-only">Previo</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-left">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18" />
              <path d="M8 12l4 4" />
              <path d="M8 12h8" />
              <path d="M12 8l-4 4" />
            </svg>
          </a>

          <button *ngFor="let page of pages"
            [ngClass]="page === pagination.currentPage ? 
              'page-link relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold line_customize line_inset_customize hover:button_color_customize template_color_customize'
              :
              'page-link relative z-10 inline-flex items-center text_white hover:text_black px-4 py-2 text-sm font-semibold line_customize line_inset_customize hover:button_color_customize'"
            (click)="goToPage(page)" [disabled]="page === '...'">
            {{ page }}
          </button>

          <!-- Flecha "Siguiente" -->
          <a (click)="nextPage()"
            class="relative inline-flex items-center text_color_customize hover:text_black px-2 py-2 line_customize line_inset_customize hover:button_color_customize rounded-r-md">
            <span class="sr-only">Próximo</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-right">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" />
              <path d="M16 12l-4 -4" />
              <path d="M16 12h-8" />
              <path d="M12 16l4 -4" />
            </svg>
          </a>
        </nav>
      </div>
    </div>
  </div>
</div>